import { Component, EventEmitter, Inject, Input, NgZone, Output, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Service } from "../../../models/service";
import { BaseError } from "../../pages/base-error";
import { GuideTypesEnum } from "../../../models/guideTypes";
import { ServiceProperties } from "../../../models/service-properties";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";

@Component({
  selector: "service-add",
  templateUrl: "./service-add.component.html",
  styles: [],
  providers: [ServiceControllerService, ToastrService],
})
export class ServiceAddComponent extends BaseError implements OnInit {

  @Input() public service: Service;
  @Input() public services: Service[] = [];
  @Input() public saveFromOutside: boolean = false;
  @Output() public formSubmit = new EventEmitter();
  @Output() public cancel = new EventEmitter();
  public isLoading: boolean = true;
  public guideTypesEnum = GuideTypesEnum;
  public guideTypesOptions: any[] = [];
  public tabsType: string =  "tabs";
  public currentRoute: string = "configuration";

  constructor(private serviceControllerService: ServiceControllerService,
              public toastr: ToastrService,
              @Inject(NgZone) protected zone: NgZone) {
    super(toastr);
  }

  public ngOnInit() {
    if (this.service.id) {
      this.serviceControllerService.getService(this.service.id).subscribe(
        (data: Service) => {
          console.log(data);
          this.service = data;
          this.initProperties();
      });
    } else {
      this.initProperties();
    }
  }

  public initProperties() {
    if (this.guideTypesEnum) {
      this.guideTypesOptions = Object.keys(this.guideTypesEnum);
    }
    if (!this.service.serviceJsonProperties) {
      this.service.serviceJsonProperties = new ServiceProperties();
    }
    if (!this.service.serviceAttributes) {
      this.service.serviceAttributes = [];
    }
    this.isLoading = false;
  }

  public updateCurrentRoute(route: string) {
    this.currentRoute = route;
    console.log(this.currentRoute);
  }

  public submit() {
    console.log("--- submittttt");
    this.formSubmit.emit(this.service);
  }

  public closeLayer() {
    this.cancel.emit();
  }

}
